module.exports = __webpack_public_path__ + "img/frame.a63438f8.png";